import langKeys from '@sdui-hq/app-internationalization/locales/de.json'
import type {Metadata} from '@/types/config/brandings/metadata.ts'

const sduiDefaultLangKeys = langKeys.variables.DEFAULT.DEFAULT
const pupilDefaultLangKeys = langKeys.variables.PUPIL.DEFAULT

const generatePupilHtmlMetadata = (): Metadata => {
  return {
    title: pupilDefaultLangKeys.APP_NAME,
    meta: {
      description: langKeys.login.login_sign_in.page_default_description
        .replace('@:{\'_vars.APP_NAME_LANG_HELPER.NOM_BEGIN\'}', pupilDefaultLangKeys.APP_NAME_LANG_HELPER.NOM_BEGIN)
        .replace('@:{\'_vars.SCHOOL_LANG_HELPER.PLURAL\'}', sduiDefaultLangKeys.SCHOOL_LANG_HELPER.PLURAL)
        .replace('@:{\'_vars.SCHOOL\'}', sduiDefaultLangKeys.SCHOOL),
      author: pupilDefaultLangKeys.COMPANY_NAME,
      copyright: pupilDefaultLangKeys.COMPANY_NAME,
      applicationName: pupilDefaultLangKeys.APP_NAME,
      appleItunesApp: 'app-id=1669668638',
      open_graph: {
        url: pupilDefaultLangKeys.APP_URL,
        image: `${pupilDefaultLangKeys.APP_URL_FULL}/brandings/pupil/favicons/favicon-192x192.png`
      }
    },
    link: {
      copyrightLink: pupilDefaultLangKeys.IMPRINT_LINK,
      favIcon: '/brandings/pupil/favicons/favicon-32x32.png'
    }
  }
}

export default generatePupilHtmlMetadata
